<template>
  <div class="navigationSection">
    <div id="info" class="clearfix">
      <ul>
        <li id="toprev">
          <router-link :to="{ name: 'pages', params: { id: nextPrev } }">
            <img
              src="@/assets/images/common/toprev.png"
              width="40px"
              alt="toprev"
            />
          </router-link>
        </li>
        <li id="tonext">
          <router-link :to="{ name: 'pages', params: { id: nextPage } }">
            <img
              src="@/assets/images/common/tonext.png"
              width="40px"
              alt="tonext"
            />
          </router-link>
        </li>
      </ul>
      <h2>{{ pages[sectionId - 1] }}</h2>
    </div>
  </div>
</template>

<script>
import pageLists from '@/mixins/PageLists.js';

export default {
  name: 'NavigationSection',
  mixins: [pageLists],
  props: {
    sectionId: Number
  },
  data() {
    return {
      maxPage: 20
    };
  },
  computed: {
    nextPrev: function() {
      var nextPrevId = this.sectionId - 1;
      if (nextPrevId == 0) {
        nextPrevId = this.maxPage;
      }
      return nextPrevId;
    },
    nextPage: function() {
      var nextPageId = this.sectionId + 1;
      if (nextPageId > this.maxPage) {
        nextPageId = 1;
      }
      return nextPageId;
    }
  }
};
</script>
